/**
 * Manage header visibility - hide on scroll down, show on scroll up
 */

/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

// Constant scalars
const delta = 5;    // Min amount to change scroll by before taking action

// Variables
let $header = null;
let didScroll = null;
let lastScrollTop = 0;
let headerHeight = null;


function initHeader() {
    // Store the initial header height
    storeHeaderHeight();

    // Set up resize listener to reassign height 
    $(window).resize((event) => {
        storeHeaderHeight();
    });

    $(window).scroll((event) => {
        didScroll = true;
    });
    
    setInterval(() => {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);
    
    function hasScrolled() {
        var st = $(window).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
    
        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > headerHeight) {
            // Scroll Down
            $('header').addClass('nav-up');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('header').removeClass('nav-up');
            }
        }
    
        lastScrollTop = st;
    }
}

function storeHeaderHeight() {
    headerHeight = $header.height();
}

exports.init = function ($el) {
    $header = $el;
    initHeader();
};